module.exports = __webpack_public_path__ + "static/media/desktop-product-shot-ttl.c3af8b6b.png";